module.exports = __webpack_public_path__ + "static/media/schaf.eecffd3c.png";